const styles = theme => ({
  root: {
    padding: theme.spacing(3),
    textAlign: 'center',
    maxWidth: 900,
    margin: '0 auto',
  },
  processingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 0),
  },
  scanner: {
    width: 120,
    height: 120,
    marginBottom: theme.spacing(4),
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:before': {
      content: '""',
      position: 'absolute',
      width: '100%',
      height: 2,
      backgroundColor: '#3B82F6',
      top: 0,
      left: 0,
      animation: '$scan 2s ease-in-out infinite',
      zIndex: 2,
    },
  },
  documentIcon: {
    fontSize: 80,
    color: '#3B82F6',
    opacity: 0.2,
  },
  '@keyframes scan': {
    '0%': { top: 0 },
    '50%': { top: '100%' },
    '100%': { top: 0 },
  },
  progressInfo: {
    width: '100%',
    maxWidth: 400,
    marginBottom: theme.spacing(2),
  },
  progressBar: {
    height: 8,
    borderRadius: 4,
    backgroundColor: '#F1F5F9',
    '& .MuiLinearProgress-bar': {
      borderRadius: 4,
      backgroundColor: '#3B82F6',
    },
  },
  stepText: {
    marginTop: theme.spacing(2),
    color: '#64748B',
    fontSize: '15px',
    fontWeight: 500,
  },
  incrementalList: {
    marginTop: theme.spacing(4),
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    maxWidth: 600,
  },
  processingFileCard: {
    padding: theme.spacing(1.5, 2),
    backgroundColor: '#FFFFFF',
    border: '1px solid #E2E8F0',
    borderRadius: 10,
    display: 'flex',
    alignItems: 'center',
    textAlign: 'left',
    animation: '$fadeIn 0.3s ease-out',
  },
  '@keyframes fadeIn': {
    from: { opacity: 0, transform: 'translateY(10px)' },
    to: { opacity: 1, transform: 'translateY(0)' },
  },
  spinner: {
    color: '#3B82F6',
    animation: '$rotate 1s linear infinite',
  },
  '@keyframes rotate': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },
  errorContainer: {
    padding: theme.spacing(4),
    backgroundColor: '#FEF2F2',
    borderRadius: 12,
    border: '1px solid #FEE2E2',
    marginTop: theme.spacing(2),
  },
  errorText: {
    color: '#DC2626',
    marginBottom: theme.spacing(3),
  },
  retryButton: {
    backgroundColor: '#DC2626',
    color: '#FFFFFF',
    textTransform: 'none',
    fontWeight: 600,
    padding: theme.spacing(1, 4),
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#B91C1C',
    },
  },
  completeContainer: {
    textAlign: 'left',
    width: '100%',
  },
  summaryTitle: {
    fontSize: '22px',
    fontWeight: 800,
    color: '#1E293B',
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  summarySubtitle: {
    fontSize: '15px',
    color: '#64748B',
    marginBottom: theme.spacing(4),
    textAlign: 'center',
  },
  courseOutlineContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(4),
  },
  courseCard: {
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    border: '1px solid #E2E8F0',
    padding: theme.spacing(2.5),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    position: 'relative',
  },
  courseHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  courseTitleField: {
    flex: 1,
    '& .MuiInputBase-input': {
      fontSize: '16px',
      fontWeight: 600,
      color: '#1E293B',
      padding: '8px 0',
    },
    '& .MuiInput-underline:before': {
      borderBottom: '1px solid transparent',
    },
    '& .MuiInput-underline:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid #E2E8F0',
    },
    '& .MuiInput-underline:after': {
      borderBottom: '2px solid #3B82F6',
    },
  },
  deleteCourseBtn: {
    color: '#94A3B8',
    padding: 8,
    '&:hover': {
      color: '#EF4444',
      backgroundColor: '#FEF2F2',
    },
  },
  reExtractButton: {
    color: '#64748B',
    backgroundColor: '#F1F5F9',
    borderRadius: '50%',
    '&:hover': {
      color: '#1E293B',
      backgroundColor: '#E2E8F0',
    },
  },
  attachmentList: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    paddingLeft: theme.spacing(0.5),
  },
  fileChip: {
    height: 32,
    backgroundColor: '#F8FAFC',
    border: '1px solid #E2E8F0',
    borderRadius: 8,
    '& .MuiChip-label': {
      fontSize: '13px',
      color: '#475569',
      fontWeight: 500,
    },
    '& .MuiChip-deleteIcon': {
      fontSize: '18px',
      color: '#94A3B8',
      '&:hover': {
        color: '#EF4444',
      },
    },
  },
  addCourseButton: {
    width: '100%',
    padding: theme.spacing(2),
    borderRadius: 12,
    border: '1px dashed #3B82F6',
    color: '#3B82F6',
    fontWeight: 600,
    textTransform: 'none',
    fontSize: '14px',
    '&:hover': {
      backgroundColor: '#EFF6FF',
      borderColor: '#2563EB',
    },
  },
  continueButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(6),
    marginBottom: theme.spacing(4),
  },
  '@keyframes pop': {
    '0%': { transform: 'scale(1)' },
    '40%': { transform: 'scale(0.85)' },
    '70%': { transform: 'scale(1.1)' },
    '100%': { transform: 'scale(1)' },
  },
  animating: {
    animation: '$pop 350ms ease-in-out',
  },
  continueButton: {
    width: 56,
    height: 56,
    backgroundColor: '#3B82F6',
    color: '#FFFFFF',
    borderRadius: '50%',
    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#2563EB',
      transform: 'scale(1.05) translateX(4px)',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '28px',
    },
  },
})

export default styles
